import React from 'react';
import { TextField } from '../core-form-fields/BaseTextField';

interface EmailFieldProps {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
}

export const EmailField: React.FC<EmailFieldProps> = ({ 
  value, 
  onChange, 
  required = false 
}) => {
  return (
    <TextField
      id="email"
      label="Email"
      type="email"
      value={value}
      onChange={onChange}
      required={required}
      validation={{
        pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        customValidation: (value) => {
          if (value.includes('..')) {
            return "Email cannot contain consecutive dots";
          }
          if (value.split('@').length > 2) {
            return "Email cannot contain multiple @ symbols";
          }
          return undefined;
        }
      }}
      placeholder="Enter your email"
    />
  );
};